module.exports = __webpack_public_path__ + "img/success.4db7cc60.svg";